import { JSONObject } from '../../types/types';
import { DatasetControlDataStatus } from './getDatasetControlDataStatus';
import { ParsedDatasetControlData } from './parseDatasetControlData';

export type DatasetControlDataEntry = {
  datasetId: string;
  // Raw param value — restored verbatim into rebuilt URLs.
  raw: string;
  data: JSONObject;
};

type DatasetControlDataEntryContext = {
  status: DatasetControlDataStatus;
  parsed: ParsedDatasetControlData;
  routeDatasetId: string | undefined;
  datasetId: string | undefined;
};

// Pure reducer for the render-time dataset control data ref: given the current
// entry and the location/dataset context, returns what the ref should hold.
// Keeps the current reference when nothing changed (idempotent render
// mutation).
export const getNextDatasetControlDataEntry = (
  current: DatasetControlDataEntry | null,
  { status, parsed, routeDatasetId, datasetId }: DatasetControlDataEntryContext
): DatasetControlDataEntry | null => {
  // Leaving the data's dataset cancels it. Forms opened from the dataset are
  // dataset-scoped routes (/dataset/X/form/…), so the data survives a form
  // round-trip; standalone form routes (/form/…) have no datasetId and clear.
  let next = current;
  if (next && routeDatasetId !== next.datasetId) {
    next = null;
  }

  if (status === 'invalid') {
    return null;
  }

  if (status === 'valid' && parsed && 'data' in parsed && datasetId) {
    if (next && next.datasetId === datasetId && next.raw === parsed.raw) {
      return next;
    }
    return { datasetId, raw: parsed.raw, data: parsed.data };
  }

  return next;
};
